export type SeasonOption = {
  id: string;
  name: string;
};

/**
 * The hall answers with one season at a time and the viewer's season_titles
 * only ever list consolidated ones, so a picker rebuilt from the current
 * response alone drops the live season the moment a past one is selected.
 * Accumulating every season seen so far keeps that door open in both
 * directions. Returns the same array when nothing new arrived, so it is safe
 * to feed straight back into state.
 */
export function accumulateSeasonOptions(
  previous: SeasonOption[],
  seen: Array<SeasonOption | null | undefined>,
): SeasonOption[] {
  const known = new Set(previous.map((option) => option.id));
  const added: SeasonOption[] = [];

  for (const option of seen) {
    if (!option || !option.id || known.has(option.id)) continue;
    known.add(option.id);
    added.push({ id: option.id, name: option.name });
  }

  return added.length ? [...previous, ...added] : previous;
}
